export default __webpack_public_path__ + "static/media/Pic4.05840f42.jpg";